import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import BackToTopButton from './components/BackToTopButton';
import FloatingVideoWidget from './components/FloatingVideoWidget';
import MobileBottomNav from './components/MobileBottomNav';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import AllServices from './pages/AllServices';
import Contact from './pages/Contact';
import Referral from './pages/Referral';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import IncomeTaxForm from './pages/IncomeTaxForm';
import ServicesForm from './pages/ServicesForm';
import Consultation from './pages/Consultation';
import PostSubmitPlaceholder from './pages/PostSubmitPlaceholder';
import { useLanguage } from './i18n/LanguageContext';

export default function AppShell() {
  const { loadingStrings, t } = useLanguage();

  if (loadingStrings) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-white gap-3">
        <div className="h-10 w-10 rounded-full border-2 border-[#14A098] border-t-transparent animate-spin" aria-hidden />
        <p className="text-sm font-medium text-[#0f2540]">{t('common.loading', 'Loading...')}</p>
      </div>
    );
  }

  return (
    <div className="App">
      <ScrollToTop />
      <Navbar />
      <main className="pb-20 lg:pb-0">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/all-services" element={<AllServices />} />
          <Route path="/services/:slug" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/referral" element={<Referral />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/file-itr" element={<IncomeTaxForm />} />
          <Route path="/get-started" element={<ServicesForm useHomeLayout />} />
          <Route path="/consultation" element={<Consultation />} />
          <Route path="/post-submit" element={<PostSubmitPlaceholder />} />
        </Routes>
      </main>
      <Footer />
      <FloatingVideoWidget />
      <WhatsAppButton />
      <BackToTopButton />
      <MobileBottomNav />
      <Toaster position="top-right" richColors />
    </div>
  );
}
